import React, { Component } from "react";
import api from "../../../utils/api";
import Header from "../../ui/header/header";
import { Form } from "semantic-ui-react";
import { MediaContainer } from "../../ui/mediaContainer/mediaContainer";
import { PrimaryButton } from "../../ui/button/button";
import { Title } from "../../ui/typography/typography";
import { TextInput, MultilineInput } from "../../ui/inputs/inputs";
import "../../ui/base/base.css";
import styles from "./updateBookmarkPage.css";

class EditUrlDataPage extends Component {
	constructor() {
		super();

		this.state = { loading: true };

		this.onSubmit = this.onSubmit.bind(this);
		this.onChange = this.onChange.bind(this);
	}

	async getData(uuid) {
		const bookmark = await api.bookmark.single(uuid);

		// Convert array of tags to string
		bookmark.tags = bookmark.tags.join(",");

		this.setState({ ...bookmark, loading: false });
	}

	componentDidMount() {
		const uuid = this.props.match.params.uuid;

		this.getData(uuid);
	}

	async onSubmit() {
		await api.bookmark.update(this.state._id, this.state);
		this.props.history.push(`/bookmark/${this.state._id}`);
	}

	onChange(e) {
		this.setState({
			...this.state,
			[e.target.name]: e.target.value
		});
	}

	render() {
		const { title, image, description, loading, tags, url } = this.state;

		return (
			<div>
				<Header history={this.props.history} />
				<Title className={styles.title}>Edit bookmark</Title>
				<Form className={styles.container} onSubmit={this.onSubmit}>
					<div className={styles.infoContainer}>
						<TextInput
							placeholder="Title"
							name="title"
							value={title}
							onChange={this.onChange}
						/>
						<TextInput
							placeholder="Url"
							name="url"
							value={url}
							onChange={this.onChange}
						/>
						<TextInput
							placeholder="Tags"
							name="tags"
							value={tags}
							onChange={this.onChange}
						/>
						<MultilineInput
							placeholder="Description"
							name="description"
							value={description}
							onChange={this.onChange}
						/>

						<PrimaryButton className={styles.button}>
							Update bookmark
						</PrimaryButton>
					</div>

					<div className={styles.mediaContainer}>
						<MediaContainer
							className={styles.mediaPrimary}
							loading={loading}
							image={image}
						/>
					</div>
				</Form>
			</div>
		);
	}
}

export default EditUrlDataPage;



// WEBPACK FOOTER //
// ./src/components/pages/updateBookmarkPage/updateBookmarkPage.js